/* eslint-disable import/prefer-default-export */
import { watch } from 'vue';
import { useForm } from 'vee-validate';
import { toValue } from '@vueuse/core';
import { useBagContext } from '@modules/add-to-bag';

import { VALIDATION_SCHEMAS, INITIAL_VALUES, GIFT_CARD_TYPE } from '../constants';
import { useGift } from './useGift';
import { useGiftPreselect } from './useGiftPreselect';

/**
 * * Gift Card Form Composable
 *
 * @description
 * This composable is used to manage the gift card form.
 *
 * @param {import('@vueuse/core').MaybeRefOrGetter<GIFT_CARD_TYPE>} giftCardType
 */
export const useGiftCardForm = (giftCardType = GIFT_CARD_TYPE.BASIC) => {
  const { selectedGift, giftOptions } = useGift(toValue(giftCardType));
  const { isUpdateBagEnabled } = useBagContext();

  const form = useForm({
    initialValues: INITIAL_VALUES[toValue(giftCardType)],
    validationSchema: VALIDATION_SCHEMAS[toValue(giftCardType)],
  });

  /**
   * @param {string|null} [newValue]
   */
  const setSelectedGiftCard = (newValue) => {
    if (newValue === null || newValue === undefined) {
      selectedGift.value = null;
      return;
    }
    const parsedValue = +newValue;
    const value = Number.isNaN(parsedValue) ? null : parsedValue;
    selectedGift.value = value;
  };

  watch(() => form.values.giftCardAmount, setSelectedGiftCard);
  watch(() => selectedGift.value, (newValue) => {
    const parsedValue = newValue === null ? '' : newValue.toString();
    if (form.values.giftCardAmount === parsedValue) {
      return;
    }
    form.values.giftCardAmount = parsedValue;
  });

  if (isUpdateBagEnabled) {
    useGiftPreselect(giftCardType, form.values, selectedGift);
  }

  return {
    ...form,
    giftOptions,
    setSelectedGiftCard,
  };
};
